import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserRightService} from '../../../services/user-right.service';
import {MessageService} from '../../../../shared/message.service';
import {AdditionalRightService} from '../../../services/additional-right.service';
import {GeneralRight} from '../../../interfaces/generalRight';
import {ServiceTools} from '../../../services/serviceTools';

@Component({
  selector: 'app-rights-selection',
  templateUrl: './rights-selection.html',
  styleUrls: ['./rights-selection.css']
})
export class RightsSelectionComponent implements OnInit {

  /**
   * The selected ids when the component is initialized.
   */
  private _rightTargets: string[];

  /**
   * Original selected right ids.
   * @param ids The selected ids.
   */
  @Input() set rightTargets(ids: string[]) {
    this._rightTargets = ids;
  }


  /**
   * Original selected right ids.
   * @param ids The selected ids.
   */
  @Input() additionalRights: boolean;

  /**
   * The event emitter of selected right change.
   */
  @Output() idsChanged: EventEmitter<string[]> = new EventEmitter<string[]>();

  /**
   * The list of simplified rights from the rest.
   */
  rights: { name: string, target: string, selected: boolean }[] = [];

  /**
   * The component is initialized.
   * @param rightService The service used to fetch rights.
   */
  constructor(
    private rightService: UserRightService,
    private additionalRightService: AdditionalRightService,
    private messageService: MessageService,
  ) {
  }

  /**
   * Selects or unselects the given right.
   * @param right
   */
  selectRight(right: { name: string, target: string, selected: boolean }) {
    if (right.selected) {
      this._rightTargets.push(right.target);
    } else {
      this._rightTargets = this._rightTargets.filter((target: string) => target !== right.target);
    }
    this._rightTargets = Array.from(new Set<string>(this._rightTargets));
    this.idsChanged.emit(this._rightTargets);
  }

  /**
   * Fetch the entities from the backend.
   */
  async fetchEntities(): Promise<void> {
    let rights: GeneralRight[];
    // try {
    rights = ServiceTools.getEntitiesFromFirstContext(
      await this.getService().getEntities(),
      this.messageService,
      'user rights');
    // rights = await this.getService().getEntities();
    // } catch (error) {
    //   this.messageService.addDanger(`Error when fetching rights from backend: ${JSON.stringify(error)}`);
    //   console.error(`Error when fetching rights from backend: ${JSON.stringify(error)}`);
    //   rights = [];
    // }

    // Select rights
    rights.forEach(
      (right: GeneralRight) => this.rights.push(
        {
          target: right.target,
          name: right.name,
          selected: this._rightTargets.some((target: string) => target === right.target)
        }));

    // Find "orphan" rights that are in the licence but not received from rights endpoint
    const orphanRights = this._rightTargets.filter((target: string) => {
      return !(this.rights.some((rightRest: { name: string, target: string, selected: boolean }) => {
        return rightRest.target === target;
      }));
    });


    // Add orphan rights to component to make sure they are not lost and they are visible
    // Show also a warning about these orphans
    if (orphanRights.length > 0) {
      this.messageService.addWarning(`The following unknown rights are in the licence: ${orphanRights}. Add them to rights endpoint`);
      orphanRights.forEach((orphan: string) => this.rights.push({target: orphan, selected: true, name: orphan}));
    }
  }

  /**
   * Returns the service to be used.
   */
  private getService(): AdditionalRightService | UserRightService {
    return this.additionalRights ? this.additionalRightService : this.rightService;
  }

  /**
   * Inits the component. Rights are fetched from backend.
   */
  async ngOnInit(): Promise<void> {
    await this.fetchEntities();
  }
}
